import IconPassengerClass from "@Icons/ticket/passengerClass/IconPassengerClass";
import matchPassengerClassTypeAndIcon from "@CheckOrder/features/classPicker/functions/matchPassengerClassTypeAndIcon";
import useCurrency from "@Currency/hooks/useCurrency";
import useGetPriceForPassengerClass from "@CheckOrder/features/classPicker/hooks/useGetPriceForPassengerClass";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";

interface SelectedPassengerClassProps {
    selectedPassengerClass: AvailablePassengerClassType,
    passengerId: number,
    isReturn: boolean,
    showDetails?: boolean
}

function SelectedPassengerClass(props: SelectedPassengerClassProps) {
    const {
        selectedPassengerClass,
        passengerId,
        isReturn,
        showDetails,
    } = props

    const {val} = useCurrency()
    const {getPrice} = useGetPriceForPassengerClass(selectedPassengerClass, passengerId, isReturn)

    const truncateTitle = (title: string) => (
        title.split("-")[0]
    )

    return (
        <div className="passenger-class">
            <div className="passenger-class__title">
                {showDetails && (
                    <IconPassengerClass
                        title={matchPassengerClassTypeAndIcon(selectedPassengerClass.type)}
                        width="24"
                        height="24"
                        className="passenger-class__icon"
                    />
                )}
                {showDetails ? selectedPassengerClass.title : truncateTitle(selectedPassengerClass.title)}
            </div>
            {showDetails && (
                <p className="passenger-class__description limited">
                    {selectedPassengerClass.description}
                </p>
            )}
            <p className="passenger-class__price center">
                {`${getPrice()} ${val}`}
            </p>
        </div>
    )
}

export default SelectedPassengerClass